import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authenticatedFetch } from '../utils/api';
import { Loader } from 'lucide-react';
import { useNotification } from '../contexts/NotificationContext';

const AdminRoute = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { addErrorNotification } = useNotification();
  
    useEffect(() => {
      const checkAdminStatus = async () => {
        try {
          const response = await authenticatedFetch('/profile');
          if (!response || response.role !== 'admin') {
            addErrorNotification('Access forbidden: insufficient privileges');
            setIsAdmin(false);
            return;
          }
          setIsAdmin(true);
        } catch (error) {
          console.error('Error checking admin status:', error);
          addErrorNotification('Error checking admin status');
          setIsAdmin(false);
        } finally {
          setIsLoading(false);
        }
      };
  
      checkAdminStatus();
    }, [addErrorNotification]);  

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader className="w-8 h-8 text-accent animate-spin" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;